import React, { useRef } from 'react'
import { HeaderContent, HomeStyles } from '../styles'

import { Column, Row } from '../../../../components/commons'
import { useDirectory } from '../../../../store/directory'

import useToast from '../../../../hooks/useToast'
import { SendEmail } from '..'
import { useForm } from 'react-hook-form'
import Input from '../../../../components/Input'
import { useNavigate } from 'react-router-dom'
import { api } from '../../../../services/api'
import { Field } from '../../../../components/Input/CheckboxInput/styles'
import axios from 'axios'
import { useUserStore } from '../../../../store/user'
import { Content } from './styles'
import {
  FaCheck,
  FaChevronRight,
  FaDownload,
  FaFileCircleExclamation,
  FaFileCirclePlus,
  FaPencil,
  FaPrint,
  FaMagnifyingGlass,
  FaFloppyDisk,
  FaFileSignature,
  FaWandMagicSparkles,
  FaShieldHalved,
} from 'react-icons/fa6'
import { ButtonRound } from '../../../../components/Header/styles'
import { useTheme } from 'styled-components'
import { Tooltip } from 'react-tooltip'
import Modal, { ModalHandle } from '../../../../components/Modals/Modal'
import ModalSignGovBr from '../../../../components/Modals/ModalSignGovBr'
import ModalSignIcpBrasil from '../../../../components/Modals/ModalSignIcpBrasil'
import ModalAnonymizeLgpd from '../../../../components/Modals/ModalAnonymizeLgpd'

export interface BreadCrumbProps {
  refetch: () => void
  id?: string
  openDocumentTypeRef?: any
  url?: any
  setList: (list: boolean) => void
  list: boolean
  documentName?: string
  onSelectAllValues: (checked: boolean) => void
  modalSideBar: any
  handleSavePdf?: () => void
  handleSignPdf?: () => void
}

const BreadCrumb: React.FunctionComponent<BreadCrumbProps> = ({
  id,
  url,
  documentName,
  openDocumentTypeRef,
  setList,
  list,
  modalSideBar,
  refetch,
  onSelectAllValues,
  handleSavePdf,
  handleSignPdf,
}) => {
  const toast = useToast()
  const theme: any = useTheme()
  const nav = useNavigate()
  const govModalRef = useRef<any>(null)
  const icpModalRef = useRef<any>(null)
  const anonymizeModalRef = useRef<any>(null)
  const { user } = useUserStore((state) => state)
  const hasPermission = user?.role === 'admin' || user?.role === 'manager'

  const [checked, setChecked] = React.useState(false)
  const directory = useDirectory((state) => state.directory)

  const [edit, setEdit] = React.useState(false)

  const { control, getValues, setValue, setFocus } = useForm<any>({
    defaultValues: {
      name: documentName,
    },
    mode: 'onChange',
  })

  const onEditName = async () => {
    setEdit(true)

    setFocus('name')
  }

  const onSaveEditName = async () => {
    try {
      setEdit(false)

      const name = getValues('name')

      await api.put(`/documents/${id}`, {
        name: name,
      })

      refetch()

      toast.successToast('Nome editado com sucesso!')
    } catch (error) {
      toast.errorToast('Erro ao editar valor!')
    }
  }

  const [isProcessingAi, setIsProcessingAi] = React.useState(false)

  const handleProcessAi = async () => {
    if (!id) return
    try {
      setIsProcessingAi(true)
      toast.infoToast('Processando documento com Gemini 2.5 Flash...')
      await api.post(`/ai/process/${id}`)
      toast.successToast('Documento classificado e metadados indexados com IA!')
      if (refetch) refetch()
    } catch (error: any) {
      toast.errorToast(error?.response?.data?.message || 'Erro ao processar com IA')
    } finally {
      setIsProcessingAi(false)
    }
  }

  const handleDownload = async () => {
    // try {
    //   window.open(String(url))
    // } catch (error) {
    //   console.log(error)
    // }

    var a = document.createElement('a') //Create <a>
    if (url) {
      a.href = window.URL.createObjectURL(url) //Image Base64 Goes here
    }
    a.download = String(documentName) //File name Here
    a.click() //Downloaded file
  }

  const handleOcr = async () => {
    try {
      if (!id) return
      toast.successToast('Processamento OCR iniciado! Você poderá buscar pelo conteúdo em breve.')
      await api.post(`/documents/${id}/ocr`)
      refetch()
    } catch (error: any) {
      toast.errorToast(error?.response?.data?.message || 'Erro ao iniciar OCR')
    }
  }

  const handlePrinting = () => {
    if (!url) return

    const blob = new Blob([url], { type: 'application/pdf' })

    const printWindow = window.open(URL.createObjectURL(blob), '_blank')
    if (printWindow) {
      printWindow.onload = () => {
        printWindow.print()
      }
    }
  }

  const onSelectFolder = (index: number) => {
    let directories = [...directory]

    directories.splice(index + 1)

    useDirectory.getState().setDirectory(directories)
    nav('/documents')
  }

  React.useEffect(() => {
    setValue('name', documentName)
  }, [documentName])

  return (
    <>
      <Tooltip
        id='my-tooltip'
        style={{ backgroundColor: theme.colors.primary, zIndex: 9999, color: 'white' }}
      />
      <Column style={{ width: '100%' }}>
        <HeaderContent.BreadCumbs>
          {directory.map((bread, index) => (
            <div
              key={bread.name}
              style={{
                display: 'inline-block',
              }}
            >
              <HomeStyles.Row onClick={() => onSelectFolder(index)}>
                <HomeStyles.BreadName>{bread.name}</HomeStyles.BreadName>
                {index < directory.length - 1 ? <FaChevronRight size={10} /> : ''}
              </HomeStyles.Row>
            </div>
          ))}
        </HeaderContent.BreadCumbs>

        <Content style={{ gap: 15 }}>
          <HomeStyles.EditName active={edit}>
            <Input
              control={control}
              disabled={!edit}
              name='name'
              type='text'
              Icon={
                hasPermission ? (
                  edit ? (
                    <ButtonRound
                      style={{
                        backgroundColor: theme.colors.success,
                      }}
                      onClick={onSaveEditName}
                    >
                      <FaCheck color='white' size={15} />
                    </ButtonRound>
                  ) : (
                    <ButtonRound onClick={onEditName}>
                      <FaPencil color='white' size={15} />
                    </ButtonRound>
                  )
                ) : undefined
              }
            />
          </HomeStyles.EditName>

          <Row gap={10}>
            <Row gap={10}>
              <Field
                checked={checked}
                type='checkbox'
                onChange={() => {
                  setChecked(!checked)
                  onSelectAllValues(!checked)
                }}
              />{' '}
              <span style={{ color: '#1e293b', fontWeight: 600, fontSize: 13 }}>Selecionar tudo</span>
            </Row>
            <ButtonRound
              data-tooltip-id='my-tooltip'
              data-tooltip-content='Editar index do documento'
              data-tooltip-place='bottom'
              onClick={() => openDocumentTypeRef.current.openFormModal(id)}
            >
              <FaFileCirclePlus color='white' size={15} />
            </ButtonRound>
            {/*       <HeaderContent.ButtonList onClick={() => setList(!list)}>
              {!list ? (
                <ButtonRound>
                  <FaTableColumns color='white' size={15} />
                </ButtonRound>
              ) : (
                <ButtonRound>
                  <FaTableList color='white' size={15} />
                </ButtonRound>
              )}
            </HeaderContent.ButtonList> */}

            <ButtonRound
              data-tooltip-id='my-tooltip'
              data-tooltip-content='Fazer impressão do documento'
              data-tooltip-place='bottom'
              onClick={() => handlePrinting()}
            >
              <FaPrint color='white' size={15} />
            </ButtonRound>

            <ButtonRound
              data-tooltip-id='my-tooltip'
              data-tooltip-content='Aplicar Reconhecimento de Texto (OCR)'
              data-tooltip-place='bottom'
              onClick={() => handleOcr()}
            >
              <FaMagnifyingGlass color='white' size={15} />
            </ButtonRound>

            {id && <SendEmail _id={id} />}
            <ButtonRound
              data-tooltip-id='my-tooltip'
              data-tooltip-content='Fazer download do documento'
              data-tooltip-place='bottom'
              onClick={() => handleDownload()}
            >
              <FaDownload color='white' size={15} />
            </ButtonRound>
            {hasPermission && handleSavePdf && (
              <ButtonRound
                style={{ backgroundColor: theme.colors.success }}
                data-tooltip-id='my-tooltip'
                data-tooltip-content='Salvar PDF modificado (Cria Nova Versão)'
                data-tooltip-place='bottom'
                onClick={handleSavePdf}
              >
                <FaFloppyDisk color='white' size={15} />
              </ButtonRound>
            )}
            {hasPermission && (
              <ButtonRound
                style={{ backgroundColor: theme.colors.warning }}
                data-tooltip-id='my-tooltip'
                data-tooltip-content='Assinar Digitalmente (Padrão ICP-Brasil / SERPRO)'
                data-tooltip-place='bottom'
                onClick={() => icpModalRef.current?.openModal(id, url)}
              >
                <FaFileSignature color='white' size={15} />
              </ButtonRound>
            )}
            {hasPermission && (
              <ButtonRound
                style={{ backgroundColor: '#005b96' }}
                data-tooltip-id='my-tooltip'
                data-tooltip-content='Assinar Eletronicamente Oficial (Gov.br)'
                data-tooltip-place='bottom'
                onClick={() => govModalRef.current?.openModal(id, url)}
              >
                <span style={{ fontSize: 15, fontWeight: 'bold' }}>BR</span>
              </ButtonRound>
            )}
            <ButtonRound
              style={{
                backgroundColor: '#059669',
                opacity: isProcessingAi ? 0.6 : 1,
                pointerEvents: isProcessingAi ? 'none' : 'auto',
              }}
              data-tooltip-id='my-tooltip'
              data-tooltip-content='Classificar e Extrair Metadados com IA (Gemini 2.5 Flash)'
              data-tooltip-place='bottom'
              onClick={isProcessingAi ? undefined : handleProcessAi}
            >
              <FaWandMagicSparkles color='white' size={15} />
            </ButtonRound>
            {hasPermission && (
              <ButtonRound
                style={{ backgroundColor: '#1e293b' }}
                data-tooltip-id='my-tooltip'
                data-tooltip-content='Anonimizar Dados Pessoais / Marca d’Água (LGPD)'
                data-tooltip-place='bottom'
                onClick={() => anonymizeModalRef.current?.openModal(id, url)}
              >
                <FaShieldHalved color='white' size={15} />
              </ButtonRound>
            )}
            <ButtonRound
              data-tooltip-id='my-tooltip'
              data-tooltip-content='Ver mais informações do documento'
              data-tooltip-place='bottom'
              onClick={() => id && modalSideBar.current?.openModal(id)}
            >
              <FaFileCircleExclamation color='white' size={15} />
            </ButtonRound>
          </Row>
        </Content>
      </Column>
      
      <ModalSignGovBr
        ref={govModalRef}
        documentId={id}
        documentName={documentName}
        documentBlob={url}
        onSuccess={refetch}
      />
      <ModalSignIcpBrasil
        ref={icpModalRef}
        documentId={id}
        documentName={documentName}
        documentBlob={url}
        onSuccess={refetch}
      />
      <ModalAnonymizeLgpd
        ref={anonymizeModalRef}
        documentId={id}
        documentName={documentName}
        documentBlob={url}
        onSuccess={refetch}
      />
    </>
  )
}

export default BreadCrumb
